<template>
  <div class="info-container">
    <div class="content">
      <template v-if="itemList.length > 0 || scrollFlag">
        <Item v-for="v in itemList" :key="v.id" :every="v" :curcer="v.id" @itemClick="goDetail">
        </Item>
        <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
      </template>
      <NoData v-if="itemList.length == 0 && !scrollFlag"></NoData>
    </div>
    <Modal v-model="qrCodeModal" title="手机查看完整会议内容" class="" @on-cancel="qrCodeModal = false" :footer-hide="true">
      <div style="width:200px;height:200px;margin:20px auto;">
        <div id="qrcodeArea" ref="qrcodeArea">
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import NoData from "@/views/PCView/search/components/NoData.vue";
import Item from "@/components/pager/Item";
import Scroll from "@/components/paging/scroll";
import mixin from "@/mixins";
import QRCode from "qrcodejs2";
export default {
  components: {
    Item,
    Scroll,
    NoData,
  },
  mixins: [mixin],
  created() {
    // 论文列表
    this.getItemList(this.params);
  },
  data() {
    return {
      scrollFlag: false,
      isEnd: false,
      total: 0,
      itemList: [],
      params: {
        columnId: '14',
        pageNo: '1',
        pageSize: '5'
      },
      beginDateTime: '',
      // 二维码弹窗
      qrCodeModal: false
    };
  },
  methods: {
    async getItemList(obj) {
      this.scrollFlag = true;
      this.isEnd = false;
      if (obj.pageNo == 1) this.beginDateTime = this.$global.transferDate(new Date());
      const resp = await this.$apis.mainServe.getlistByColumnId({
        ...obj,
        beginDateTime: this.beginDateTime
      });
      this.total = +resp.data.total;
      this.itemList.push(...resp.data.list);
      this.scrollFlag = false;
      this.isEnd = obj.pageNo >= this.total / 5;
    },
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "meetingDetails",
        query: {
          id: e.id,
          type: 8,
          goodsId:e.goodsId,
        },
      });

      window.open(routeUrl.href, "_blank");

      // 弹窗显示二维码引导至H5查看详情
      // this.qrCodeModal = true;
      // if (!this.qr) {
      //   this.$nextTick(() => {
      //     // 生成H5
      //     this.qr = new QRCode(this.$refs.qrcodeArea, {
      //       width: 200,
      //       height: 200, // 高度
      //       text: location.protocol+'//'+location.hostname + routeUrl.href, // 二维码内容
      //     });
      //   })
      // }
    },
  },
}
</script>

<style></style>